import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { environment } from '../../../environments/environment';

declare const grecaptcha: any;

@Injectable({ providedIn: 'root' })
export class RecaptchaService {
  private readonly siteKey = environment.recaptcha.siteKey;

  execute(action: string): Observable<string> {
    return from(
      new Promise<string>((resolve, reject) => {
        grecaptcha.ready(() => {
          grecaptcha.execute(this.siteKey, { action })
            .then((token: string) => resolve(token))
            .catch((err: any) => reject(err));
        });
      })
    );
  }
}